// extracted by mini-css-extract-plugin
export var actionButton = "_k5-0";
export var fileInput = "_k5-2";
export var paperclip = "_k5-1";